<template>
  <div class="row">
    <div class="col-md-12 pb-3">
      <h3 class="rel-title-menu">Conóceme</h3>
      <hr class="rel-hr-title" />
      <p
        class="rel-paragraph pl-4 pr-4"
      >Estudiante de Ingeniería Multimedia con experiencia en la creación y edición de contenidos para sitios web, desarrollo de aplicaciones y trabajo en equipo. Manejo programas como Adobe Illustrator, Photoshop, Premiere Pro y Wordpress; también lenguajes de programación, tales como HTML, CSS, JavaScript, C# y Java, sin embargo, cuento con la capacidad de acoplarme fácilmente a un nuevo lenguaje o programa de desarrollo. Por otro lado, soy una persona entusiasta, apasionada y proactiva para las tareas que me son asignadas. Cuento con la habilidad para encontrar la solución a problemas que se presenten de forma rápida y efectiva.</p>
      <h4 class="mt-5">Intereses</h4>
      <div class="d-flex flex-wrap justify-content-between p-4 rel-bg-content-2">
        <div class="rel-item-interest d-flex m-1">
          <i class="fas fa-gamepad mr-3 rel-icon"></i>
          <p class="m-0 p-0">Videojuegos</p>
        </div>
        <div class="rel-item-interest d-flex m-1">
          <i class="fas fa-music mr-3 rel-icon"></i>
          <p class="m-0 p-0">Música</p>
        </div>
        <div class="rel-item-interest d-flex m-1">
          <i class="fas fa-tv mr-3 rel-icon"></i>
          <p class="m-0 p-0">Anime</p>
        </div>
        <div class="rel-item-interest d-flex m-1">
          <i class="fas fa-book-open mr-3 rel-icon"></i>
          <p class="m-0 p-0">DC Animated</p>
        </div>
      </div>
      <h4 class="mt-4">Habilidades</h4>
      <div class="d-flex flex-wrap justify-content-between p-4 rel-bg-content-2">
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">HTML</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 70%"
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
            >70%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">CSS</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 60%"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
            >60%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Wordpress</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 50%"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >50%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Java</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 50%"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >50%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">MYSQL</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 50%"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >50%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">JavaScript</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 70%"
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
            >70%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Unity</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 60%"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
            >60%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">React</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 65%"
              aria-valuenow="65"
              aria-valuemin="0"
              aria-valuemax="100"
            >65%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Vue</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 50%"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            >50%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Adobe Illustrator</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 60%"
              aria-valuenow="60"
              aria-valuemin="0"
              aria-valuemax="100"
            >60%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Adobe Premier</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 70%"
              aria-valuenow="70"
              aria-valuemin="0"
              aria-valuemax="100"
            >70%</div>
          </div>
        </div>
      </div>
      <h4 class="mt-4">Idiomas</h4>

      <div class="d-flex flex-wrap justify-content-around pt-4 pb-4 rel-bg-content-2">
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Español (natal)</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 90%"
              aria-valuenow="90"
              aria-valuemin="0"
              aria-valuemax="100"
            >90%</div>
          </div>
        </div>
        <div class="rel-item-hability m-1 w-md-25">
          <p class="m-0 p-0">Inglés</p>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              style="width: 50%"
              aria-valuenow="40"
              aria-valuemin="0"
              aria-valuemax="100"
            >50%</div>
          </div>
        </div>
      </div>
      <h4 class="mt-4">Experiencia Laboral</h4>
      <div class="container-fluid">
        <div class="row justify-content-between pl-4 pr-4">
          <!--  -->
           <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                <h5 class="mb-0">Monitor logístico</h5>
                <p class="text-secondary mb-3 mt-0">Febrero de 2015 - Abril de 2019</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                <p
                  class="rel-paragraph-proyect text-white-50 text-justify p-0"
                >Desarrollo de páginas web en Wordpress, actualizador de contenido de páginas y envío de correos masivos con Mailchimp, ademas de creacion de plantillas</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
           <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                <h5 class="mb-0">Auxiliar Operativo</h5>
                <p class="text-secondary mb-3 mt-0">Marzo de 2019 - Agosto de 2019</p>
                
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                <p
                  class="rel-paragraph-proyect text-white-50 text-justify p-0"
                >Desarrollo de los contenidos audiovisuales de los cursos virtuales de la plataforma UAO Virtual, ademas de soporte en la plataforma moodle</p>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="col-md-5 rel-bg-content-2 pt-3 pb-3 mt-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <i class="fas fa-award rel-icon"></i>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <h5 class="mb-0">Desarrollador de Experiencias Interactivas</h5>
                  <p class="text-secondary mb-3 mt-0">Septiembre de 2019 - Diciembre de 2019</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p
                    class="rel-paragraph-proyect text-white-50 text-justify p-0"
                  >Desarrollo de una aplicación multimedia actualizable y administrable para realizar recorridos virtuales y yincanas de forma virtual para la Universidad Autónoma de Occidente.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style>
</style>